import script from "./DateSlide.vue?vue&type=script&setup=true&lang=js"
export * from "./DateSlide.vue?vue&type=script&setup=true&lang=js"

import "./DateSlide.vue?vue&type=style&index=0&id=62d774ae&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62d774ae"]])

export default __exports__